
export default {
    data() {
        return {
            series: [{
                name: "Population",
                data: this.dataset.map(a => a.value)
            }],
            chartOptions: {
                chart: {
                    height: 350,
                    type: 'line',
                    zoom: {
                        enabled: false
                    },
                    toolbar: {
                        show: false
                    }
                },
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    curve: 'smooth'
                },
                markers: {
                    size: 4,
                    colors: ["#FF4560"],
                    strokeColors: "#fff",
                    strokeWidth: 2,
                    hover: {
                        size: 7,
                    }
                },
                grid: {
                    row: {
                        colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                        opacity: 0.5,
                    },
                },
                xaxis: {
                    categories: this.dataset.map(a => a.year),
                }
            },
        };
    },
    props: {
        id: { type: String, default: 'line-chart'},
        dataset : Array,
        title: String,
    },
};
